<template>
  <div class="sponsors">
    <md-table v-if="$store.state.pageLoaded" class="small-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" v-on:click="editCreateDialogVisible = true; createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptySponsor))" title="Dodaj sponzora" v-if="$store.state.schema.sponsor.create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Sponzori</h1>
        </div>
      </md-table-toolbar>

      <md-table-row>
        <md-table-head>Poslovni partner</md-table-head>
        <md-table-head class="t-align-center">Akcije</md-table-head>
      </md-table-row>

      <md-table-row md-selectable="single" md-auto-select v-for="item in $store.state.receivedData.sponsors.list" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item))">
        <md-table-cell>{{ item.title }}</md-table-cell>
        <md-table-cell class="actions-cell">
          <md-button class="md-icon-button md-accent" v-on:click="deleteDialog = true" title="Obriši" v-if="$store.state.schema.sponsor.delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="editCreateDialogVisible = true; editDialog = true;" title="Uredi"  v-if="$store.state.schema.sponsor.update">
            <md-icon>edit</md-icon>
          </md-button>
          <md-button class="md-icon-button md-primary" v-on:click="partnerDialog = true;" title="Informacije">
            <md-icon>info</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje sponzora"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" v-if="$store.state.selectedObject !== undefined" class="md-scrollbar overflow-visible">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('season', $store.state.selectedObject)">
              <label>Sezona</label>
              <md-select v-model="$store.state.selectedObject.season">
                <md-option v-for="season in $store.state.receivedData.seasonsList.list" :value="season.id">{{ season.title }}</md-option>
              </md-select>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <Autocomplete v-model="$store.state.selectedObject.partner" :getValue="partnerTitle" :stateObject="'partners'" :returnField="'id'" :searchBy="'title'" :label="'Odaberi partnera'"/>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="createOrUpdate" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>

    <md-dialog :md-active.sync="partnerDialog" class="md-scrollbar">
      <md-dialog-title>{{ partner.title }} - Sezona {{ getTitle('seasonsList', $store.state.selectedObject.season) }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <div class="full-width">
              <h3>{{ partner.title }}</h3>
              <p>
                {{ partner.oib }}<br>
                {{ partner.address }}<br>
                {{ partner.postal_code }}, {{ partner.city }}
              </p>
            </div>
            <div v-if="partner.contact_person !== undefined">
              <h3 v-if="partner.contact_person.length > 1">Kontakt osobe</h3>
              <h3 v-else>Kontakt osoba</h3>
              <div v-for="person in partner.contact_person" class="full-width">
                <p>
                  <strong>{{ person.first_name }} {{ person.last_name }}</strong><br>
                  <strong>Email:</strong> {{ person.email }}<br>
                  <strong>Broj mobitela:</strong> {{ person.mobile_phone }}
                </p>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import ListingMixin from '../../../mixins/listing-mixin.js'

export default {
  name: 'Sponsors',
  data(){
    return {
      partnerDialog: false,
      partnerTitle: '',
      emptySponsor: {
        season: '',
        partner: '',
        data: {
          contact_person: []
        }
      },
      requiredFields: ['season', 'partner'],
    }
  },

  mixins: [ListingMixin('sponsors', 'sponzora')],

  computed:{
    partner(){
      let partner = this.$store.state.receivedData.partners.list.filter((partner) =>{return partner.id == this.$store.state.selectedObject.partner})[0];

      if(partner !== undefined) return partner;
      else return [];
    }
  },

  methods:{
    getTitle(stateObject, id){
      let object = this.$store.state.receivedData[stateObject].list.filter((object) =>{return object.id == id})[0];
      return object !== undefined ? object.title : '';
    }
  },

  watch:{
    editDialog(value){
      if(value){

      }
    }
  }
}
</script>

<style lang="scss">
.md-field{
  &.checkbox-validation{
    padding-top: 0;
    min-height: auto;
    &:before, &:after{
      display: none;
    }
  }
}

.overflow-visible{
  overflow: visible !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/Sponsors.vue